import { doc, setDoc } from 'firebase/firestore';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { firestore } from '@/lib/firebase';

// Global engineering-mode flag, exposed to external services via the public
// GET /api/v1/engineering endpoint on monitoringDashboardApi.
const configRef = doc(firestore, 'configs', 'engineering');

export function useEngineeringConfig() {
  return useDocumentData(configRef);
}

export function setEngineeringMode(enabled: boolean) {
  return setDoc(configRef, { enabled }, { merge: true });
}
